import { useState } from 'react';
import css from './knowledge-base.module.scss';
import PageHeader from 'src/components/page-header/page-header';
import { KBFilter, KBSection } from 'src/types';
import KnowledgeBaseFilter from './filter';
import { useGetSections } from './data/queries';
import EmptyPlaceholder from 'src/components/empty-placeholder/empty-placeholder';
import ImageCard from 'src/components/image-card/image-card';
import { Carousel } from 'src/components/carousel/carousel';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as ArrowRight } from 'src/assets/arrow-long-right.svg';
import CarouselCard from 'src/components/carousel/carousel-card';

function KnowledgeBase() {
  const navigate = useNavigate();
  const [filter, setFilter] = useState<KBFilter>({
    search: '',
    page: 1,
    limit: 15
  });

  const { data: sections, isPending } = useGetSections(filter);

  const handleFilterChange = (data: Partial<KBFilter>) => setFilter({ ...filter, ...data });

  const goToModule = (slug: string) => navigate(slug);

  const goToMaterial = (slug: string, module: string) => navigate(`${slug}/${module}`);

  return (
    <main className={css.knowledge}>
      <PageHeader
        title='База знань'
        description={
          'Розділ містить корисні ресурси для цивільно-військового співробітництва, включаючи статті, посібники та дослідження.'
        }
        filter={<KnowledgeBaseFilter initialValues={filter} onSubmit={handleFilterChange} />}
      />
      <div className={css.body}>
        <div className={css.container}>
          {sections?.length === 0 && (
            <EmptyPlaceholder
              title='За Вашим запитом поки немає навчальних матеріалів'
              pageSearchMsg='Спробуйте знайти інший навчальний матеріал'
            />
          )}
          <div className={css.cards}>
            {isPending && skeletons}
            {sections?.length > 0 &&
              sections.map((c: KBSection) => (
                <ImageCard key={c.id} title={c.title} imgUrl={c.imgUrl} onClick={() => goToModule(c.slug)} />
              ))}
          </div>
          {sections?.length > 0 &&
            sections.map((c: KBSection) => (
              <div className={css.carusel_block} key={`${c.id}-cards`}>
                <Carousel
                  data={c.modules.map((item) => (
                    <CarouselCard
                      key={item.id}
                      item={item}
                      onClick={(module: string) => goToMaterial(c.slug, module)}
                    />
                  ))}
                  title={<h2>{c.title}</h2>}
                  itemsToShow={c.modules.length >= 2 ? 2 : c.modules.length}
                />
                <div className={css.carousel_image_block} onClick={() => goToModule(c.slug)} aria-hidden>
                  <div className={css.blur}>
                    <h3>{c.title}</h3>
                    <ArrowRight />
                  </div>
                  <img src={c.imgUrl} alt={c.imgUrl} />
                </div>
              </div>
            ))}
        </div>
      </div>
    </main>
  );
}

export default KnowledgeBase;

export const skeletons = [...Array(6).keys()].map((i) => <span key={i} className={css.skeleton} />);
